import { render, staticRenderFns } from "./MenuProfile.vue?vue&type=template&id=1bd5ff34"
import script from "./MenuProfile.vue?vue&type=script&lang=js"
export * from "./MenuProfile.vue?vue&type=script&lang=js"
import style0 from "./MenuProfile.vue?vue&type=style&index=0&id=1bd5ff34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports